import { createVuetify } from 'vuetify'
import { VApp } from 'vuetify/components/VApp'
import { VBtn } from 'vuetify/components/VBtn'
import { VCard, VCardActions, VCardText, VCardTitle } from 'vuetify/components/VCard'
import { VCheckbox } from 'vuetify/components/VCheckbox'
import { VDialog } from 'vuetify/components/VDialog'
import { VForm } from 'vuetify/components/VForm'
import { VCol, VContainer, VRow, VSpacer } from 'vuetify/components/VGrid'
import { VIcon } from 'vuetify/components/VIcon'
import { VMain } from 'vuetify/components/VMain'
import { VProgressCircular } from 'vuetify/components/VProgressCircular'
import { VSnackbar } from 'vuetify/components/VSnackbar'
import { VTextField } from 'vuetify/components/VTextField'
import { VTooltip } from 'vuetify/components/VTooltip'
import { VFadeTransition } from 'vuetify/components/transitions'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import { appIconAliases } from './icons'
import 'vuetify/styles'
import '@/assets/main.css'
import palette from '@/theme'

// Keep application colors aligned with the generated public-page theme.
export default createVuetify({
  components: {
    VApp, VBtn, VCard, VCardActions, VCardText, VCardTitle, VCheckbox, VDialog, VForm, VCol, VContainer, VRow, VSpacer, VIcon, VMain, VProgressCircular, VSnackbar, VTextField, VTooltip, VFadeTransition
  },
  defaults: {
    VBtn: {
      color: 'grey-lighten-3',
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases: { ...aliases, ...appIconAliases },
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      dark: {
        colors: {
          primary: palette.navigation,
          accent: palette.accent,
          secondary: "#FEFEFE",
          success: "#4CAF50",
          info: "#2196F3",
          warning: "#FB8C00",
          error: "#FF5252",
        }
      },
      light: {
        colors: {
          background: palette.background,
          surface: palette.surface,
          'on-background': palette.ink,
          'on-surface': palette.ink,
          'on-primary': '#ffffff',
          'on-accent': '#ffffff',
          'on-secondary': '#ffffff',
          'surface-variant': palette.muted,
          'on-surface-variant': '#ffffff',
          primary: palette.navigation,
          accent: palette.accent,
          secondary: "#909090",
          success: "#4CAF50",
          info: "#2196F3",
          warning: "#FB8C00",
          error: "#FF5252",
        }
      },
    },
  },
})
